export default __webpack_public_path__ + "static/media/img6.c38aca85.jpeg";